import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import { fullWeek } from '../../../../constants/date-format';
import { PickupSettingsDayPropType } from '../../../../prop-types/pickup-settings-day';
import { createLookupHash } from '../../../../services/hash-service';
import StartThroughClosingTime from '../../components/start-through-closing-time';
import { WAREHOUSE_SETTINGS_URL } from '../constants';
import messages from '../messages';
import style from '../style.module.less';

const PickupSettingsSchedule = ({ shipFromId, pickupSettings = null }) => {
  if (pickupSettings) {
    const { days } = pickupSettings;
    const { day: firstDay, startTime: firstStartTime, endTime: firstEndTime } = days[0];
    const { day: lastDay } = days[days.length - 1];
    const isSameSchedule = days.reduce((isSame, day) => isSame && day.startTime === firstStartTime && day.endTime === firstEndTime, true);
    const isConsecutiveDays = fullWeek.join('').includes(days.map((day) => day.day).join('')) && days.length > 1;
    const userDefinedWorkdayMap = createLookupHash(days, 'day');
    const fullWeekSchedule = fullWeek.map((day) => ({
      name: day,
      formattedName: <FormattedMessage {...messages[day]} />,
      isClosed: !userDefinedWorkdayMap[day],
      startThroughEndTime: userDefinedWorkdayMap[day] ? (
        <StartThroughClosingTime {...userDefinedWorkdayMap[day]} />
      ) : (
        <FormattedMessage {...messages.closed} />
      ),
    }));
    const closedDaySchedule = fullWeekSchedule.filter(({ isClosed }) => isClosed);

    return (
      <>
        <div className={style['pickup-settings-schedule']}>
          {isSameSchedule && isConsecutiveDays ? (
            <>
              <div>
                <FormattedMessage {...messages[firstDay]} />
                {' - '}
                <FormattedMessage {...messages[lastDay]} />
              </div>
              <StartThroughClosingTime endTime={firstEndTime} startTime={firstStartTime} />
              {closedDaySchedule.map((day) => (
                <>
                  <div>{day.formattedName}</div>
                  <div>{day.startThroughEndTime}</div>
                </>
              ))}
            </>
          ) : (
            fullWeekSchedule.map((day) => (
              <>
                <div>{day.formattedName}</div>
                <div>{day.startThroughEndTime}</div>
              </>
            ))
          )}
        </div>
        <Link to={`${WAREHOUSE_SETTINGS_URL}/${shipFromId}/pickup-settings`}>
          <FormattedMessage {...messages.seeExtendedSchedule} />
        </Link>
      </>
    );
  }
  return (
    <BannerMessageV2
      bannerContainerClassName={style['child-wrapper']}
      className={style['no-schedule-warning']}
      content={
        <FormattedMessage
          {...messages.noScheduleSet}
          values={{
            link: (chunks) => (
              <Link className={style['contact-error-link']} to={`${WAREHOUSE_SETTINGS_URL}/${shipFromId}/pickup-settings`}>
                {chunks}
              </Link>
            ),
          }}
        />
      }
      status={BannerStatus.Warning}
    />
  );
};

PickupSettingsSchedule.propTypes = {
  shipFromId: PropTypes.string.isRequired,
  pickupSettings: PropTypes.shape({
    days: PropTypes.arrayOf(PickupSettingsDayPropType),
  }),
};

export default PickupSettingsSchedule;
